import React, { useEffect, useState } from "react";

import styled from "../tenders/style.module.css";

import api from "../../utils/ApiMethod";
import img from "../../assets/images/Download.jpeg";
import Styles from "../../styles/Tender.module.css";
import { Helmet } from "react-helmet-async";
const Advertisement = () => {
  const advertisement = [
    {
      id: 1,
      name: "Five players from Bihar selected in Asian Games",
      date: "06.10.2023",
      expiryDate: "",
      url: "img/advertisements/asian_game_advertisement_bihar_sport.pdf",
    },
  ];

  const [data, setData] = useState([]);

  const [search, setSearch] = useState("");

  const handleFetchData = async () => {
    try {
      const data = await api.fetchData("/Advertisement");
      setData(data);
      // console.log("Fetched data:", data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // useEffect(() => {
  //   handleFetchData();
  // }, []);

  return (
    // <div>
    <div className={styled.Container}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Advertisements - Bihar State Sports Authority</title>
        <meta name="description" content="Access official advertisements and notifications from the Bihar State Sports Authority regarding sports initiatives and opportunities in Bihar." />
      </Helmet>

      <h1 className="pt-2" style={{ marginBottom: "10px" }}>
        Advertisement
      </h1>
      <p style={{ marginBottom: "10px" }}>
        All official advertisements will be announced on this page. Please visit regularly for the latest updates.
      </p>
      {/* input field for search the item */}
      {/* <div class={styled.input_group}>
        <div class="form-outline">
          <input
            type="search"
            id="form1"
            class="form-control"
            placeholder="Search for Advertisement"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>
      <table class="table table-striped ">
        <thead>
          <tr class="table-primary">
            <th className={`${Styles.th}`} scope="col">
              Sr.No.
            </th>
            <th className={`${Styles.head}`} scope="col">
              Subject  
            </th>
            <th className={`${Styles.head}`} scope="col">
              {" "}
              Date
            </th>
            <th className={`${Styles.head}`} scope="col">
              Last date
            </th>
            <th className={`${Styles.head}`} scope="col">
              Download
            </th>
          </tr>
        </thead>
        <tbody>
          {advertisement &&
            advertisement
              // .filter((item) =>
              //   item.name.toLowerCase().includes(search.toLowerCase())
              // )
              .map((item, i) => (
                <tr>
                  <th scope="row">{i + 1}</th>
                  <td
                    className={Styles.table_cell}
                    style={{ textAlign: "left" }}
                  >
                    {item.name}
                  </td>
                  <td
                    className={Styles.table_cell}
                    style={{ textAlign: "left" }}
                  >
                    {item.date}
                  </td>

                  <td
                    className={Styles.table_cell}
                    style={{ textAlign: "left" }}
                  >
                    {item.expiryDate}
                  </td>

                  <td
                    className={Styles.table_cell}
                    style={{ textAlign: "left" }}
                  >
                    <a href={item.url} target="_blank">
                      <img className={Styles.table_image} src={img} />
                    </a>
                  </td>
                </tr>
              ))}
        </tbody>
      </table>
    </div> */}
    </div>
  );
};

export default Advertisement;
